module.exports = __webpack_public_path__ + "assets/img/63@3x.c92672a8.png";